
(function() {
  var result = { translations: { "de": { "foundations-components": { "ActionsMenu": { "defaultAriaLabel": "Aktionen" }, "tag": { "remove": "Tag entfernen" }, "Select": { "noResults": "Keine Ergebnisse gefunden.", "searchPlaceholder": "Suchen ...", "clearSelections": "Auswahlen aufheben" }, "ErrorMessage": { "error": { "title": "Da ist wohl etwas schiefgegangen." }, "notFound": { "title": "Irgendwo im Nirgendwo" }, "badRequest": { "title": "Beim Laden dieser Seite ist ein Problem aufgetreten." }, "expired": { "title": "Es tut uns leid." }, "sessionId": { "prefix": "Sitzungs-ID:" } }, "ProgressSteps": { "completedStep": "Abgeschlossener Schritt", "incompleteStep": "Unvollst\xE4ndiger Schritt" }, "Paginator": { "label": "Seitennummerierung", "pageNumber": { "currentIndicator": "Sie sind gerade auf ", "description": "Seite " }, "firstPage": { "label": "Erster", "description": "Erste Seite" }, "previousPage": { "label": "Zur\xFCck", "description": "Vorherige Seite" }, "nextPage": { "label": "Weiter", "description": "N\xE4chste Seite" }, "lastPage": { "label": "Zuletzt", "description": "Letzte Seite" } }, "Datagrid": { "noData": { "Title": "Es sind keine Daten vorhanden.", "Description": "Keine Daten verf\xFCgbar." }, "noResults": { "Title": "Keine Ergebnisse gefunden.", "Description": "Passen Sie Ihre Suche und Ihre Filter an, um zu finden, wonach Sie suchen.", "ClearActionLabel": "Such- und Filterauswahl aufheben" }, "toolbar": { "selectedRows": { "one": "{{count}} Zeile ausgew\xE4hlt", "other": "{{count}} Zeilen ausgew\xE4hlt", "clearSelection": "Auswahl l\xF6schen", "selectAll": "Alle {{totalRows}} Zeilen ausw\xE4hlen" }, "search": { "placeholder": "Suchen", "label": "Suchen", "clearSearch": "Suche l\xF6schen" } }, "pagination": { "visibleRows": "{{visibleRows}} von {{totalRows}} Ergebnissen", "itemsPerPage": "Elemente pro Seite", "countPerPage": { "one": "{{count}} pro Seite", "other": "{{count}} pro Seite" } }, "SkeletonGrid": { "loading": "Wird geladen" }, "DataGridColumnManagementPanel": { "description": "W\xE4hlen Sie, welche Eigenschaften als Spalten angezeigt werden sollen. Verschieben Sie dann die Eigenschaften nach oben oder unten oder ziehen Sie sie per Drag & Drop, um die Reihenfolge zu \xE4ndern, in der sie angezeigt werden.", "removeAllColumns": "Alle Spalten entfernen", "update": "Aktualisieren", "cancel": "Abbrechen", "edit": "Spalten bearbeiten" } } }, "ui": { "UIAbstractPageSection": { "page": "Seitenabschnitt" }, "UICarousel": { "current": "{{currentStepDisplayNumber}} von {{totalSteps}} Elementen werden angezeigt", "prev": "Zur\xFCck", "next": "Weiter", "tip": "Verwenden Sie die Pfeiltasten, um andere Elemente anzuzeigen" }, "UIColorSwatch": { "label": "Farbauswahl {{value}}", "noColorLabel": "Farbauswahl, keine Farbe ausgew\xE4hlt." }, "UIButtonCollapser": { "dropdownLabel": "Aktionen" }, "UIErrorMessage": { "error": { "title": "Oh nein!" }, "notFound": { "title": "Irgendwo im Nirgendwo" }, "badRequest": { "title": "Beim Laden dieser Seite ist ein Problem aufgetreten." }, "expired": { "title": "Es tut uns leid." } }, "UIPanelNavigator": { "backButton": "Gehe zum vorherigen Bildschirm" }, "UILoadingSpinner": { "busyText": "Wird geladen", "completedText": "Ladevorgang abgeschlossen" }, "UISideNav": { "navigationLandmark": "Sekund\xE4r" }, "UISortTH": { "ascendingSort": "Aufsteigende Sortierung. Dr\xFCcken Sie, um absteigend zu sortieren.", "descendingSort": "Absteigende Sortierung. Dr\xFCcken Sie, um aufsteigend zu sortieren.", "pressToSort": "Dr\xFCcken Sie, um zu sortieren." }, "autosizedTextInput": { "charactersRemaining": "Noch {{value}} Zeichen" }, "time": { "today": "Heute um {{time}}", "yesterday": "Gestern um {{time}}", "datetime": "{{date}} um {{time}}" }, "progress": { "percentComplete": "{{percent}} abgeschlossen" }, "datePicker": { "dateSelected": "{{date}} ist ausgew\xE4hlt.", "noDateSelected": "Kein Datum ausgew\xE4hlt.", "dateBelowMin": "Sie m\xFCssen ein neueres Datum ausw\xE4hlen.", "dateAboveMax": "Sie m\xFCssen ein \xE4lteres Datum ausw\xE4hlen.", "invalidDate": "Ung\xFCltiges Datum", "today": "Heute", "clear": "L\xF6schen", "placeholder": { "month": "MM", "day": "TT", "year": "JJJJ" }, "nextMonth": "N\xE4chster Monat", "prevMonth": "Vorheriger Monat" }, "dateRange": { "startDate": "Startdatum", "endDate": "Enddatum", "endDateBeforeStartDate": "Das Enddatum muss nach dem Startdatum liegen.", "startDateAfterEndDate": "Das Startdatum muss vor dem Enddatum liegen.", "to": "bis" }, "timePicker": { "placeholder": { "hour": "HH", "minute": "MM" } }, "SelectResultList": { "andMore": "... und {{count}} weitere.", "loadMore": "Mehr laden" } }, "salesUI": { "UIAvatarAdd": { "ariaLabel": "Hinzuf\xFCgen" }, "UIAvatarHoverlay": { "text": "Foto \xE4ndern" }, "UIChangeArrow": { "decrease": "Abnahme von ", "increase": "Zunahme von " }, "UICopyInput": { "label": "Kopieren", "title": "In Zwischenablage kopieren", "tooltipCopied": "Kopiert" }, "UIConfirm": { "defaultConfirm": "Ja", "defaultReject": "Nein" }, "UICloseButton": { "label": "Schlie\xDFen" }, "UIDateRangePicker": { "rangeType": { "ALL": "Seit Beginn", "THIS_DAY": "Heute", "LAST_DAY": "Gestern", "THIS_WEEK": "Diese Woche", "LAST_WEEK": "Letzte Woche", "THIS_MONTH": "Diesen Monat", "LAST_MONTH": "Letzter Monat", "LAST_THIRTY_DAYS": "Letzte 30 Tage", "LAST_THREE_MONTHS": "Letzte 3 Monate", "THIS_QUARTER": "Dieses Quartal", "LAST_QUARTER": "Letztes Quartal", "THIS_YEAR": "Dieses Jahr", "LAST_YEAR": "Letztes Jahr", "CUSTOM": "Benutzerdefinierter Zeitraum" } }, "UIDropdownSelect": { "placeholder": "Kein Wert ausgew\xE4hlt" }, "UIEditableControls": { "cancel": "Abbrechen", "save": "Speichern" }, "UIExpandableText": { "collapseButtonText": "Weniger anzeigen", "expandButtonText": "Mehr anzeigen" }, "UIFileInput": { "defaultChangeLabel": "Datei \xE4ndern", "defaultSelectLabel": "W\xE4hlen Sie eine Datei aus" }, "UIIconRating": { "ariaValueText": "{{value}} von {{maxValue}}" }, "UILink": { "externalTitle": "Link wird in einem neuen Fenster ge\xF6ffnet." }, "UILoading": { "title": "Wird geladen \u2026" }, "UILockBadge": { "title": "Diese Funktion ist gesperrt" }, "UIPaginator": { "label": "Seitennummerierung", "pageNumber": { "currentIndicator": "Sie sind gerade auf ", "description": "Seite " }, "firstPage": { "label": "Erster", "description": "Erste Seite" }, "previousPage": { "label": "Zur\xFCck", "description": "Vorherige Seite" }, "nextPage": { "label": "Weiter", "description": "N\xE4chste Seite" }, "lastPage": { "label": "Zuletzt", "description": "Letzte Seite" } }, "UIPreviousButton": { "label": "Zur\xFCck" }, "UINextButton": { "label": "Weiter" }, "UINumberRating": { "lowRangeLabel": "Stimme \xFCberhaupt nicht \xFCberein", "highRangeLabel": "Stimme voll \xFCberein" }, "UISearchableSelectInput": { "placeholder": "Suchen" }, "UISearchInput": { "placeholder": "Suchen", "minimumSearchMessage": { "one": "Noch 1 Zeichen eingeben", "other": "Noch {{count}} Zeichen eingeben" }, "clearButton": "Eingabe l\xF6schen" }, "UISelect": { "allOptionsSelected": "Alle Optionen sind ausgew\xE4hlt.", "createOption": "Option \u201E{{label}}\u201C erstellen", "plusMore": "+ {{count}} weitere", "andMore": "... und {{count}} weitere.", "loadMore": "Mehr laden", "noResults": "Keine Ergebnisse gefunden.", "placeholder": "Suchen", "typeToSearch": "Tippen, um zu suchen" }, "UITable": { "selectableTableRow": { "toggleSelection": "Auswahl der Zeile umschalten" } }, "UITabs": { "moreDropdownLabel": "Mehr" }, "UITeaseNotification": { "optionsButtonTooltipText": "Optionen anzeigen" }, "UITimePicker": { "placeholder": "W\xE4hlen Sie einen Zeitpunkt aus" }, "UIToggle": { "checkedLabel": "AN", "uncheckedLabel": "DEAKTIVIERT" }, "UITypeahead": { "noMatchesFound": "Keine Treffer gefunden", "noOptions": "Keine" }, "UIWizard": { "back": "Zur\xFCck", "cancel": "Abbrechen", "done": "Fertig", "next": "Weiter", "stepCount": "Schritt {{stepNumber}} von {{stepCount}}" }, "XSSTooltip": { "explanation": "Dieser Link wurde zu Ihrer Sicherheit deaktiviert." } } } } };
  result.translationsLoaded = {
  "foundations-components": {
    "de": "static-1.5829"
  }
};
  result.translationsAvailable = {
  "foundations-components": {
    "af": "static-1.5829",
    "ar-eg": "static-1.5829",
    "bg": "static-1.5829",
    "bn": "static-1.5829",
    "ca-es": "static-1.5829",
    "cs": "static-1.5829",
    "da": "static-1.5829",
    "de": "static-1.5829",
    "el": "static-1.5829",
    "en-gb": "static-1.5829",
    "en": "static-1.5829",
    "es-mx": "static-1.5829",
    "es": "static-1.5829",
    "et": "static-1.5829",
    "fi": "static-1.5829",
    "fr-ca": "static-1.5829",
    "fr": "static-1.5829",
    "he-il": "static-1.5829",
    "hi": "static-1.5829",
    "hr": "static-1.5829",
    "hu": "static-1.5829",
    "id": "static-1.5829",
    "it": "static-1.5829",
    "ja": "static-1.5829",
    "ko": "static-1.5829",
    "lt": "static-1.5829",
    "ms": "static-1.5829",
    "nl": "static-1.5829",
    "no": "static-1.5829",
    "pl": "static-1.5829",
    "pt-br": "static-1.5829",
    "pt-pt": "static-1.5829",
    "ro": "static-1.5829",
    "ru": "static-1.5829",
    "sk": "static-1.5829",
    "sl": "static-1.5829",
    "sv": "static-1.5829",
    "th": "static-1.5829",
    "tl": "static-1.5829",
    "tr": "static-1.5829",
    "uk": "static-1.5829",
    "vi": "static-1.5829",
    "zh-cn": "static-1.5829",
    "zh-hk": "static-1.5829",
    "zh-tw": "static-1.5829"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:foundations-components:de', {version: 'static-1.5829'}); }
})();



(function() {
  var result = { translations: { "de": { "placeholder": "Platzhalter" } } };
  result.translationsLoaded = {
  "UIComponents": {
    "de": "static-3.7104"
  }
};
  result.translationsAvailable = {
  "UIComponents": {
    "af": "static-3.7104",
    "ar-eg": "static-3.7104",
    "bg": "static-3.7104",
    "bn": "static-3.7104",
    "ca-es": "static-3.7104",
    "cs": "static-3.7104",
    "da": "static-3.7104",
    "de": "static-3.7104",
    "el": "static-3.7104",
    "en-gb": "static-3.7104",
    "en": "static-3.7104",
    "es-mx": "static-3.7104",
    "es": "static-3.7104",
    "et": "static-3.7104",
    "fi": "static-3.7104",
    "fr-ca": "static-3.7104",
    "fr": "static-3.7104",
    "he-il": "static-3.7104",
    "hi": "static-3.7104",
    "hr": "static-3.7104",
    "hu": "static-3.7104",
    "id": "static-3.7104",
    "it": "static-3.7104",
    "ja": "static-3.7104",
    "ko": "static-3.7104",
    "lt": "static-3.7104",
    "ms": "static-3.7104",
    "nl": "static-3.7104",
    "no": "static-3.7104",
    "pl": "static-3.7104",
    "pt-br": "static-3.7104",
    "pt-pt": "static-3.7104",
    "ro": "static-3.7104",
    "ru": "static-3.7104",
    "sk": "static-3.7104",
    "sl": "static-3.7104",
    "sv": "static-3.7104",
    "th": "static-3.7104",
    "tl": "static-3.7104",
    "tr": "static-3.7104",
    "uk": "static-3.7104",
    "vi": "static-3.7104",
    "zh-cn": "static-3.7104",
    "zh-hk": "static-3.7104",
    "zh-tw": "static-3.7104"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:UIComponents:de', {version: 'static-3.7104'}); }
})();



(function() {
  var result = { translations: { "de": { "app": { "htmlTitle": "Benutzeroberfl\xE4che f\xFCr virale Links", "welcomeHome": "Willkommen zu Hause, {{ firstName }}", "yourAppIsReady": "Ihre App ist bereit", "aSecondPage": "Eine zweite Seite f\xFCr mehr Content", "fillPage_jsx": function (createElement, options, props) { return createElement( options, "wrapper", null, "F\xFCllen Sie diese leere Seite mit ", createElement( options, "Link", props.linkProps, "Komponenten" ), " unter ", createElement( options, "code", null, props.filename ), "." ); }, "viralLinks": { "forms": { "linkCta": "<strong>Erstellen Sie Ihre eigenen kostenlosen Formulare</strong>, um Leads \xFCber Ihre Website zu generieren." }, "liveChat": { "linkCta": "<strong>Livechat nutzen.</strong> Kostenlos Websitebesucher kontaktieren.", "ariaLabel": "Livechat hinzuf\xFCgen. Treten Sie mit Besuchern in Kontakt. Kostenlos." }, "liveChatIntermediate": { "linkCta": "<strong>[Int] Livechat nutzen.</strong> Kostenlos Websitebesucher kontaktieren.", "ariaLabel": "[Int] Livechat nutzen. Kostenlos Websitebesucher kontaktieren." }, "meetings": { "linkCta": "<strong>Erstellen Sie Ihre kostenlose Meeting-Buchungsseite</strong>, um Meetings schneller zu planen." } } } } } };
  result.translationsLoaded = {
  "embedded-viral-link-ui": {
    "de": "static-1.4894"
  }
};
  result.translationsAvailable = {
  "embedded-viral-link-ui": {
    "af": "static-1.4894",
    "ar-eg": "static-1.4894",
    "bg": "static-1.4894",
    "bn": "static-1.4894",
    "ca-es": "static-1.4894",
    "cs": "static-1.4894",
    "da": "static-1.4894",
    "de": "static-1.4894",
    "el": "static-1.4894",
    "en-gb": "static-1.4894",
    "en": "static-1.4894",
    "es-mx": "static-1.4894",
    "es": "static-1.4894",
    "et": "static-1.4894",
    "fi": "static-1.4894",
    "fr-ca": "static-1.4894",
    "fr": "static-1.4894",
    "he-il": "static-1.4894",
    "hi": "static-1.4894",
    "hr": "static-1.4894",
    "hu": "static-1.4894",
    "id": "static-1.4894",
    "it": "static-1.4894",
    "ja": "static-1.4894",
    "ko": "static-1.4894",
    "lt": "static-1.4894",
    "ms": "static-1.4894",
    "nl": "static-1.4894",
    "no": "static-1.4894",
    "pl": "static-1.4894",
    "pt-br": "static-1.4894",
    "pt-pt": "static-1.4894",
    "ro": "static-1.4894",
    "ru": "static-1.4894",
    "sk": "static-1.4894",
    "sl": "static-1.4894",
    "sv": "static-1.4894",
    "th": "static-1.4894",
    "tl": "static-1.4894",
    "tr": "static-1.4894",
    "uk": "static-1.4894",
    "vi": "static-1.4894",
    "zh-cn": "static-1.4894",
    "zh-hk": "static-1.4894",
    "zh-tw": "static-1.4894"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:embedded-viral-link-ui:de', {version: 'static-1.4894'}); }
})();


